import root from '../../utils/root';
import fetchJSON from '../../utils/fetch/fetchJSON';
import getHCStorage from '../storage-manager/getHCStorage';
import storePhoneNumber from '../storage-manager/storePhoneNumber';
import config from '../config';
import defaultPhone from './defaultPhone';

/**
 * @private
 * Gets common parameters.
 *
 * @param  {Object} phone - the phone object to send
 * @param  {Object} hcStorage - the `hc` object in the storage
 * @return {Object}
 */
function getCommonParameters(phone, hcStorage) {
  const replaceRegex = /medicareguide\.com$/.test(document.domain) ? /(?:stg|local|qa|www)\./i : /(?:stg|local|qa)\./i;

  phone.src = hcStorage.source;
  phone.gclid = hcStorage.gclid;
  phone.ircid = hcStorage.ircid;
  phone.btsid = hcStorage.bt_sid;
  phone.state = hcStorage.location.state_acronym;
  phone.hcsid = hcStorage.healthcareSession;
  phone.site = document.domain.replace(replaceRegex, '');
  phone.requesturl = encodeURIComponent(root.location.host + root.location.pathname);
  phone.domain = phone.site;
  phone.placement = '';
  phone.goal_url = '';
  phone.channel = '';
  phone.subid = hcStorage.subid;
  return phone;
}

/**
 * @public
 * Gets the phone number and updates the `invoca_phone` in `localStorage`
 *
 * @param  {Object} options - parameters to send: `{goal_url, placement, channel, ...}`
 * @return {Promise}
 */
function getPhoneNumber(options) {
  const hcStorage = getHCStorage();
  const phone = hcStorage.invoca_phone;

  if (phone && phone.promo_number && phone.source && phone.source === hcStorage.source) {
    return Promise.resolve(phone);
  }

  getCommonParameters(defaultPhone, hcStorage);

  return fetchJSON({
    // https://github.com/healthcarecom/sem-content/blob/master/README.md#get-phone-number
    url: `${config.serviceDomain}/v2/phone`, // invoca phone
    data: Object.assign(defaultPhone, options),
  }).then(storePhoneNumber);
}

export default getPhoneNumber;
